import { Component } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
class Page extends Component {
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsx(Flex, {
      "data-test-id": "app-container",
      id: "knowledge-content-ui-app",
      flexDirection: "column",
      flexGrow: "1",
      children: children
    });
  }
}
export default Page;